// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.106.2/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

.ae-readme_modal-content_j19N2 {
  max-width: 750px;
}

.ae-readme_Modaltab_u7HXo {
  position: relative;
  height: 35px;
}

.ae-readme_Modaltab_u7HXo::after {
  content: '';
  position: absolute;
  width: calc(100% / var(--total-tabs));
  left: calc(var(--active-index) * (100% / var(--total-tabs)));
  bottom: 0;
  height: 2px;
  background-color: var(--looks-secondary);
  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);
}

.ae-readme_body_ibn3q {
  background: var(--ui-modal-background);
  padding: 0.5rem;
  min-height: 200px;
  max-height: calc(100vh - 250px);
  overflow-y: auto;
}

.ae-readme_body_ibn3q pre {
  max-width: 100% !important;
  min-width: 0 !important;
  overflow-x: auto !important;
  box-sizing: border-box !important;
  font-family: Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace !important;
}

.ae-readme_body_ibn3q pre > code[class*='language-'] {
  display: block !important;
  width: -webkit-max-content;
  width: max-content;
  min-width: 100%;
  font-family: inherit !important;
}

.ae-readme_tab-button-enable_vYdth,
.ae-readme_tab-button-unable_Yx_oU {
  border: none;
  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);
  height: 30px;
  line-height: 1.5;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-bottom: inset transparent;
  -webkit-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);
  -moz-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);
  -ms-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);
  -o-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);
  background: var(--ui-modal-background);
  filter: brightness(0.8);
  -webkit-filter: brightness(0.8);
}

.ae-readme_tab-button-enable_vYdth:active,
.ae-readme_tab-button-unable_Yx_oU:active {
  border-bottom: inset var(--looks-secondary);
}

.ae-readme_tab-button-enable_vYdth {
  /* filter: brightness(0.8) disable */
  filter: brightness(1);
  background: var(--ui-modal-background);
}

.ae-readme_tab-button-unable_Yx_oU:hover {
  filter: brightness(0.9);
  -webkit-filter: brightness(0.9);
}

.ae-readme_tab-button-enable_vYdth:hover {
  filter: brightness(1.1);
  -webkit-filter: brightness(1.1);
}

.ae-readme_tab-button-enable_vYdth:active,
.ae-readme_tab-button-unable_Yx_oU:active {
  filter: brightness(0.9);
  background: var(--ui-modal-background);
}

.ae-readme_content_Xw8hn {
  flex-grow: 1;
}

.ae-readme_title-box_Nt0HQ {
  top: 20px;
  margin: 20px;
  display: flex;
  justify-content: space-between;
}

.ae-readme_apply_UiWdT {
  margin-top: auto;
  display: flex;
  justify-content: flex-end;
}

.ae-readme_title_ovpUs {
  font-size: large;
  font-weight: bold;
}

.ae-readme_color-input_B8RmB {
  border: none;
}

/* For small screens, such as in the embed */

@media (max-height: 600px) {
  .ae-readme_modal-content_j19N2 {
    margin: 50px auto;
  }

  .ae-readme_body_ibn3q {
    max-height: calc(100vh - 150px);
  }
}

.ae-readme_setting_IIPmp {
  display: flex;
  flex-direction: column;
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
}

.ae-readme_setting_IIPmp.ae-readme_active_Un161 {
  background: var(--badge-background);
}

.ae-readme_setting_IIPmp:hover,
.ae-readme_setting_IIPmp:focus-within {
  background: var(--badge-border);
}

.ae-readme_label_k9IEG {
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
}

.ae-readme_setting_IIPmp table {
  border-collapse: collapse;
}

.ae-readme_setting_IIPmp tr,
.ae-readme_setting_IIPmp td,
.ae-readme_setting_IIPmp th {
  padding: 0;
  margin: 0;
  border: 1px solid var(--ui-tertiary);
}

.ae-readme_checkbox_NtcZe {
  margin-right: 0.5rem;
}

.ae-readme_info_WOsDf {
  margin-bottom: 0.25rem;
}

.ae-readme_header_yYgHc {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 0.5rem 0 0 0;
  font-weight: bold;
}

.ae-readme_divider_V6EtX {
  flex-grow: 1;
  margin-left: 1rem;
  border-top: 1px dashed var(--ui-tertiary);
}

.ae-readme_button_HSv_y {
  font-family: inherit;
  font-size: 14px;
  background-color: var(--looks-secondary);
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  margin: 0;
  border-radius: 4px;
  cursor: pointer;
  font-family: inherit;
  font-weight: bold;
}

.ae-readme_button_HSv_y:active,
.ae-readme_button_HSv_y:focus-within {
  box-shadow: 0 0 0 3px var(--looks-transparent);
}

.ae-readme_warning_d_x8y {
  padding: 0.5rem 1rem;
  margin: 0.25rem 0;
  border-radius: 4px;
  background: rgb(233, 233, 53);
  color: var(--text-primary-default);
}

/* Content CSS of README */

.ae-readme_body_ibn3q blockquote {
  border-left: 4px solid var(--looks-secondary);
  padding-left: 1rem;
  margin: 0.5rem 0;
}

.ae-readme_readme-alert_xqJlE {
  margin: 0.75rem 0;
  padding: 0.75rem 1rem;
  border-left: 4px solid #6e7781;
  background: #f6f8fa;
  color: #24292f;
}

.ae-readme_readme-alert_xqJlE > :last-child {
  margin-bottom: 0;
}

.ae-readme_readme-alert-title_FJt40 {
  margin: 0 0 0.5rem;
  font-size: 0.95rem;
  font-weight: bold;
}

.ae-readme_readme-alert-note_JvpGI {
  border-left-color: #0969da;
  background: #0969da0a;
  color: var(--ui-modal-foreground);
}

.ae-readme_readme-alert-note_JvpGI .ae-readme_readme-alert-title_FJt40 {
  color: #0969da;
}

.ae-readme_readme-alert-tip_ZUxOf {
  border-left-color: #1a7f37;
  background: #1a7f370a;
  color: var(--ui-modal-foreground);
}

.ae-readme_readme-alert-tip_ZUxOf .ae-readme_readme-alert-title_FJt40 {
  color: #1a7f37;
}

.ae-readme_readme-alert-important_D7nyS {
  border-left-color: #8250df;
  background: #8250df0a;
  color: var(--ui-modal-foreground);
}

.ae-readme_readme-alert-important_D7nyS .ae-readme_readme-alert-title_FJt40 {
  color: #8250df;
}

.ae-readme_readme-alert-warning_WJMzG {
  border-left-color: #9a6700;
  background: #9a67000a;
  color: var(--ui-modal-foreground);
}

.ae-readme_readme-alert-warning_WJMzG .ae-readme_readme-alert-title_FJt40 {
  color: #9a6700;
}

.ae-readme_readme-alert-caution_BHtok {
  border-left-color: #cf222e;
  background: #cf222e0a;
  color: var(--ui-modal-foreground);
}

.ae-readme_readme-alert-caution_BHtok .ae-readme_readme-alert-title_FJt40 {
  color: #cf222e;
}
`, "",{"version":3,"sources":["webpack://./src/components/ae-readme/ae-readme.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,qCAAqC;EACrC,4DAA4D;EAC5D,SAAS;EACT,WAAW;EACX,wCAAwC;EACxC,qDAAqD;AACvD;;AAEA;EACE,sCAAsC;EACtC,eAAe;EACf,iBAAiB;EACjB,+BAA+B;EAC/B,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,2BAA2B;EAC3B,iCAAiC;EACjC,wFAAwF;AAC1F;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,kBAAkB;EAClB,eAAe;EACf,+BAA+B;AACjC;;AAEA;;EAEE,YAAY;EACZ,oDAAoD;EACpD,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,gCAAgC;EAChC,4DAA4D;EAC5D,yDAAyD;EACzD,wDAAwD;EACxD,uDAAuD;EACvD,sCAAsC;EACtC,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,2CAA2C;AAC7C;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;EACrB,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;AACjC;;AAEA;;EAEE,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,SAAS;EACT,YAAY;EACZ,aAAa;EACb,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;AACd;;AAEA,4CAA4C;;AAE5C;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,+BAA+B;EACjC;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,mCAAmC;AACrC;;AAEA;;EAEE,+BAA+B;AACjC;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;;;EAGE,UAAU;EACV,SAAS;EACT,oCAAoC;AACtC;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,oBAAoB;EACpB,eAAe;EACf,wCAAwC;EACxC,YAAY;EACZ,YAAY;EACZ,oBAAoB;EACpB,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,8CAA8C;AAChD;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;EAClB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA,0BAA0B;;AAE1B;EACE,6CAA6C;EAC7C,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,8BAA8B;EAC9B,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,qBAAqB;EACrB,iCAAiC;AACnC;;AAEA;EACE,cAAc;AAChB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n.modal-content {\n  max-width: 750px;\n}\n\n.Modaltab {\n  position: relative;\n  height: 35px;\n}\n\n.Modaltab::after {\n  content: '';\n  position: absolute;\n  width: calc(100% / var(--total-tabs));\n  left: calc(var(--active-index) * (100% / var(--total-tabs)));\n  bottom: 0;\n  height: 2px;\n  background-color: var(--looks-secondary);\n  transition: all 0.15s cubic-bezier(0, 0.7, 0.3, 0.99);\n}\n\n.body {\n  background: var(--ui-modal-background);\n  padding: 0.5rem;\n  min-height: 200px;\n  max-height: calc(100vh - 250px);\n  overflow-y: auto;\n}\n\n.body pre {\n  max-width: 100% !important;\n  min-width: 0 !important;\n  overflow-x: auto !important;\n  box-sizing: border-box !important;\n  font-family: Inconsolata, Monaco, Consolas, 'Courier New', Courier, monospace !important;\n}\n\n.body pre > code[class*='language-'] {\n  display: block !important;\n  width: -webkit-max-content;\n  width: max-content;\n  min-width: 100%;\n  font-family: inherit !important;\n}\n\n.tab-button-enable,\n.tab-button-unable {\n  border: none;\n  transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);\n  height: 30px;\n  line-height: 1.5;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  border-bottom: inset transparent;\n  -webkit-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);\n  -moz-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);\n  -ms-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);\n  -o-transition: all 0.3s cubic-bezier(0, 0.7, 0.3, 0.99);\n  background: var(--ui-modal-background);\n  filter: brightness(0.8);\n  -webkit-filter: brightness(0.8);\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n  border-bottom: inset var(--looks-secondary);\n}\n\n.tab-button-enable {\n  /* filter: brightness(0.8) disable */\n  filter: brightness(1);\n  background: var(--ui-modal-background);\n}\n\n.tab-button-unable:hover {\n  filter: brightness(0.9);\n  -webkit-filter: brightness(0.9);\n}\n\n.tab-button-enable:hover {\n  filter: brightness(1.1);\n  -webkit-filter: brightness(1.1);\n}\n\n.tab-button-enable:active,\n.tab-button-unable:active {\n  filter: brightness(0.9);\n  background: var(--ui-modal-background);\n}\n\n.content {\n  flex-grow: 1;\n}\n\n.title-box {\n  top: 20px;\n  margin: 20px;\n  display: flex;\n  justify-content: space-between;\n}\n\n.apply {\n  margin-top: auto;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.title {\n  font-size: large;\n  font-weight: bold;\n}\n\n.color-input {\n  border: none;\n}\n\n/* For small screens, such as in the embed */\n\n@media (max-height: 600px) {\n  .modal-content {\n    margin: 50px auto;\n  }\n\n  .body {\n    max-height: calc(100vh - 150px);\n  }\n}\n\n.setting {\n  display: flex;\n  flex-direction: column;\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n}\n\n.setting.active {\n  background: var(--badge-background);\n}\n\n.setting:hover,\n.setting:focus-within {\n  background: var(--badge-border);\n}\n\n.label {\n  height: 32px;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n}\n\n.setting table {\n  border-collapse: collapse;\n}\n\n.setting tr,\n.setting td,\n.setting th {\n  padding: 0;\n  margin: 0;\n  border: 1px solid var(--ui-tertiary);\n}\n\n.checkbox {\n  margin-right: 0.5rem;\n}\n\n.info {\n  margin-bottom: 0.25rem;\n}\n\n.header {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  margin: 0.5rem 0 0 0;\n  font-weight: bold;\n}\n\n.divider {\n  flex-grow: 1;\n  margin-left: 1rem;\n  border-top: 1px dashed var(--ui-tertiary);\n}\n\n.button {\n  font-family: inherit;\n  font-size: 14px;\n  background-color: var(--looks-secondary);\n  color: white;\n  border: none;\n  padding: 0.5rem 1rem;\n  margin: 0;\n  border-radius: 4px;\n  cursor: pointer;\n  font-family: inherit;\n  font-weight: bold;\n}\n\n.button:active,\n.button:focus-within {\n  box-shadow: 0 0 0 3px var(--looks-transparent);\n}\n\n.warning {\n  padding: 0.5rem 1rem;\n  margin: 0.25rem 0;\n  border-radius: 4px;\n  background: rgb(233, 233, 53);\n  color: var(--text-primary-default);\n}\n\n/* Content CSS of README */\n\n.body blockquote {\n  border-left: 4px solid var(--looks-secondary);\n  padding-left: 1rem;\n  margin: 0.5rem 0;\n}\n\n.readme-alert {\n  margin: 0.75rem 0;\n  padding: 0.75rem 1rem;\n  border-left: 4px solid #6e7781;\n  background: #f6f8fa;\n  color: #24292f;\n}\n\n.readme-alert > :last-child {\n  margin-bottom: 0;\n}\n\n.readme-alert-title {\n  margin: 0 0 0.5rem;\n  font-size: 0.95rem;\n  font-weight: bold;\n}\n\n.readme-alert-note {\n  border-left-color: #0969da;\n  background: #0969da0a;\n  color: var(--ui-modal-foreground);\n}\n\n.readme-alert-note .readme-alert-title {\n  color: #0969da;\n}\n\n.readme-alert-tip {\n  border-left-color: #1a7f37;\n  background: #1a7f370a;\n  color: var(--ui-modal-foreground);\n}\n\n.readme-alert-tip .readme-alert-title {\n  color: #1a7f37;\n}\n\n.readme-alert-important {\n  border-left-color: #8250df;\n  background: #8250df0a;\n  color: var(--ui-modal-foreground);\n}\n\n.readme-alert-important .readme-alert-title {\n  color: #8250df;\n}\n\n.readme-alert-warning {\n  border-left-color: #9a6700;\n  background: #9a67000a;\n  color: var(--ui-modal-foreground);\n}\n\n.readme-alert-warning .readme-alert-title {\n  color: #9a6700;\n}\n\n.readme-alert-caution {\n  border-left-color: #cf222e;\n  background: #cf222e0a;\n  color: var(--ui-modal-foreground);\n}\n\n.readme-alert-caution .readme-alert-title {\n  color: #cf222e;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modal-content": `ae-readme_modal-content_j19N2`,
	"modalContent": `ae-readme_modal-content_j19N2`,
	"Modaltab": `ae-readme_Modaltab_u7HXo`,
	"modaltab": `ae-readme_Modaltab_u7HXo`,
	"body": `ae-readme_body_ibn3q`,
	"tab-button-enable": `ae-readme_tab-button-enable_vYdth`,
	"tabButtonEnable": `ae-readme_tab-button-enable_vYdth`,
	"tab-button-unable": `ae-readme_tab-button-unable_Yx_oU`,
	"tabButtonUnable": `ae-readme_tab-button-unable_Yx_oU`,
	"content": `ae-readme_content_Xw8hn`,
	"title-box": `ae-readme_title-box_Nt0HQ`,
	"titleBox": `ae-readme_title-box_Nt0HQ`,
	"apply": `ae-readme_apply_UiWdT`,
	"title": `ae-readme_title_ovpUs`,
	"color-input": `ae-readme_color-input_B8RmB`,
	"colorInput": `ae-readme_color-input_B8RmB`,
	"setting": `ae-readme_setting_IIPmp`,
	"active": `ae-readme_active_Un161`,
	"label": `ae-readme_label_k9IEG`,
	"checkbox": `ae-readme_checkbox_NtcZe`,
	"info": `ae-readme_info_WOsDf`,
	"header": `ae-readme_header_yYgHc`,
	"divider": `ae-readme_divider_V6EtX`,
	"button": `ae-readme_button_HSv_y`,
	"warning": `ae-readme_warning_d_x8y`,
	"readme-alert": `ae-readme_readme-alert_xqJlE`,
	"readmeAlert": `ae-readme_readme-alert_xqJlE`,
	"readme-alert-title": `ae-readme_readme-alert-title_FJt40`,
	"readmeAlertTitle": `ae-readme_readme-alert-title_FJt40`,
	"readme-alert-note": `ae-readme_readme-alert-note_JvpGI`,
	"readmeAlertNote": `ae-readme_readme-alert-note_JvpGI`,
	"readme-alert-tip": `ae-readme_readme-alert-tip_ZUxOf`,
	"readmeAlertTip": `ae-readme_readme-alert-tip_ZUxOf`,
	"readme-alert-important": `ae-readme_readme-alert-important_D7nyS`,
	"readmeAlertImportant": `ae-readme_readme-alert-important_D7nyS`,
	"readme-alert-warning": `ae-readme_readme-alert-warning_WJMzG`,
	"readmeAlertWarning": `ae-readme_readme-alert-warning_WJMzG`,
	"readme-alert-caution": `ae-readme_readme-alert-caution_BHtok`,
	"readmeAlertCaution": `ae-readme_readme-alert-caution_BHtok`
};
export default ___CSS_LOADER_EXPORT___;
